import { StyleSheet } from "react-native";
import { appColors, appFonts, fontSize } from "../../appTheme";

export const storeSettingsStyle = StyleSheet.create({
    containerStyle: {
        flex: 1, backgroundColor: appColors.lightBackgroundColor
    },
    activityView: {
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: appColors.lightBackgroundColor
    },
    scrollViewStyle: {
        paddingVertical: 10, paddingHorizontal: 5
    },
    generalDetailsView: {
        flexDirection: "row", justifyContent: 'space-between'
    },
    generalDetailsTextView: {
        fontSize: fontSize.mediumFontSize, fontFamily: appFonts.bold, color: appColors.lightDark, marginTop: 10, marginLeft: 10
    },
    commonImageView: {
        flex: 0.2, alignItems: 'flex-start'
    },
    buttonView: {
        flexDirection: 'row', alignSelf: 'flex-end', marginTop: 15
    },
    cardContainer: {
        borderRadius: 7, borderColor: appColors.light, borderWidth: 0, marginBottom: 10
    },
    tipView: {
        flexDirection: 'row', justifyContent: 'space-between'
    },
    toolTipView: {
        marginLeft: 10, marginTop: 3
    },
    buttonStyle: {
        width: 100, borderRadius: 7, borderWidth: 1
    },
    titleStyle: {
        fontFamily: appFonts.bold, fontSize: fontSize.mediumFontSize
    }
})